export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_14.41631f2c.jpg";